var CONFIG = {
  nombre:   "José Álvarez",
  cargo:    "Fundador de Tapzo",
  telefono: "+34686442458",
  whatsapp: "34686442458",
  email:    "tiendatapzo@gmail.com",
  web:      "https://tapzo.es",
  mensajeWA:"Hola 👋 Acabo de tocar la placa Tapzo y quiero más información"
};

(function () {
  document.documentElement.classList.add('js');
  var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  $$('[data-wa]').forEach(function (a) {
    a.href = 'https://wa.me/' + CONFIG.whatsapp + '?text=' + encodeURIComponent(CONFIG.mensajeWA);
    a.target = '_blank'; a.rel = 'noopener';
  });
  $$('[data-tel]').forEach(function (a) { a.href = 'tel:' + CONFIG.telefono; });
  $$('[data-mail]').forEach(function (a) { a.href = 'mailto:' + CONFIG.email; });
  $$('[data-name]').forEach(function (e) { e.textContent = CONFIG.nombre; });
  $$('[data-role]').forEach(function (e) { e.textContent = CONFIG.cargo; });
  $$('[data-initials]').forEach(function (e) {
    e.textContent = CONFIG.nombre.split(' ').map(function (w) { return w[0]; }).slice(0, 2).join('').toUpperCase();
  });
  var yr = document.getElementById('year');
  if (yr) yr.textContent = new Date().getFullYear();

  function vcard() {
    var parts = CONFIG.nombre.split(' ');
    var first = parts[0], rest = parts.slice(1).join(' ');
    return ['BEGIN:VCARD', 'VERSION:3.0',
      'N:' + rest + ';' + first + ';;;', 'FN:' + CONFIG.nombre,
      'ORG:Tapzo', 'TITLE:' + CONFIG.cargo,
      'TEL;TYPE=CELL,VOICE:' + CONFIG.telefono,
      'EMAIL;TYPE=INTERNET,WORK:' + CONFIG.email,
      'URL:' + CONFIG.web,
      'NOTE:Reseñas de Google a un toque.', 'END:VCARD'].join('\r\n');
  }
  $$('[data-vcard]').forEach(function (b) {
    b.addEventListener('click', function () {
      var url = URL.createObjectURL(new Blob([vcard()], { type: 'text/vcard;charset=utf-8' }));
      var a = document.createElement('a');
      a.href = url; a.download = 'Tapzo.vcf';
      document.body.appendChild(a); a.click(); a.parentNode.removeChild(a);
      setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
    });
  });

  function showAll() { $$('.reveal').forEach(function (el) { el.classList.add('is-in'); }); }
  function fillCounters() {
    $$('[data-count]').forEach(function (el) { el.textContent = el.dataset.count + (el.dataset.suffix || ''); });
  }

  if (!('IntersectionObserver' in window)) {
    showAll(); fillCounters();
  } else {
    var io = new IntersectionObserver(function (es, obs) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); obs.unobserve(e.target); }
      });
    }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });

    var cio = new IntersectionObserver(function (es, obs) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, end = +el.dataset.count, sfx = el.dataset.suffix || '';
        obs.unobserve(el);
        if (reduce || !end) { el.textContent = end + sfx; return; }
        var t0 = performance.now(), dur = 1500;
        var tick = function (t) {
          var p = Math.min((t - t0) / dur, 1);
          el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3))) + sfx;
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
    }, { threshold: .6 });
    $$('[data-count]').forEach(function (el) { cio.observe(el); });

    setTimeout(function () {
      if (!document.querySelector('.reveal.is-in')) { showAll(); fillCounters(); }
    }, 2500);
  }

  var pill = document.getElementById('navpill'),
      dock = document.getElementById('dock'),
      fill = document.getElementById('progress');
  var queued = false;
  function onScroll() {
    var y = scrollY, h = document.documentElement.scrollHeight - innerHeight;
    pill.classList.toggle('is-stuck', y > 24);
    dock.classList.toggle('is-visible', y > 520);
    fill.style.transform = 'scaleX(' + (h > 0 ? y / h : 0) + ')';
    queued = false;
  }
  addEventListener('scroll', function () {
    if (!queued) { queued = true; requestAnimationFrame(onScroll); }
  }, { passive: true });
  onScroll();

  if (!reduce && matchMedia('(pointer:fine)').matches) {
    var shot = document.getElementById('shot');
    if (shot) {
      shot.addEventListener('pointermove', function (e) {
        var r = shot.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        shot.style.transform = 'perspective(1100px) rotateY(' + (x * 9) + 'deg) rotateX(' + (-y * 9) + 'deg)';
      });
      shot.addEventListener('pointerleave', function () { shot.style.transform = ''; });
    }
  }

  $$('#faqs .faq').forEach(function (faq) {
    var btn = faq.querySelector('.faq__q');
    btn.addEventListener('click', function () {
      var open = faq.classList.contains('is-open');
      $$('#faqs .faq').forEach(function (f) {
        f.classList.remove('is-open');
        f.querySelector('.faq__q').setAttribute('aria-expanded', 'false');
      });
      if (!open) { faq.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    });
  });
})();
